import React from "react";
import PropTypes from "prop-types";

const shortenString = (str) => {
  if (str.length <= 8) {
    return str; // If the string is too short, just return it as is
  }
  return `${str.slice(0, 4)}...${str.slice(-4)}`;
};

const AccountAddress = ({ address }) => {
  return <span>{shortenString(address)}</span>;
};

AccountAddress.propTypes = {
  address: PropTypes.string.isRequired,
};

export default AccountAddress;
